// Payment + tax status of a purchase, shared by the desktop "Payment Status" column and the mobile card.
// payment: 'notPaid' | 'partial' | 'paid'
// tax:     'notPaid' | 'partial' | 'paid', or null when the purchase has no TDS/TCS
export const getPurchasePaymentStatus = (rowData) => {
    //Get Taxable Billvalue
    let purchaseMaterials = rowData.purchaseMaterials
    let commissionAmount = 0;
    if(purchaseMaterials !== undefined){
        purchaseMaterials.forEach((purchaseMaterial) => {
            if (purchaseMaterial.commissionPerUnit > 0 ) {
                if (purchaseMaterial.weightType === 1) {
                    commissionAmount += (purchaseMaterial.billWeight * (purchaseMaterial.commissionPerUnit));
                } else {
                    commissionAmount += (purchaseMaterial.deliveryWeight *  ( purchaseMaterial.commissionPerUnit));
                }
            }
        })
    }
    let gstAmount = 0;
    if (rowData && rowData.purchaseMaterials) {
        rowData.purchaseMaterials.forEach(purchaseMaterial => {
            let gstTaxAmt = parseFloat((purchaseMaterial.billValue * (purchaseMaterial.gst / 100)).toFixed(2))
            gstAmount += gstTaxAmt
        })
    }
    let remaningBalance = (rowData.totalBillValue + gstAmount - ((rowData.totalBillValue * (rowData.tcs / 100))) - (rowData.totalBillValue * (rowData.tds/100)) - rowData.totalAmountPaid).toFixed(2)

    let remaningBalanceWithoutTaxes = (((rowData.totalBillValue -commissionAmount)  * (rowData.tcs / 100)) + ((rowData.totalBillValue -commissionAmount)  * (rowData.tds/100)))  - rowData.totalTaxAmountPaid

    let payment = 'notPaid'
    if (rowData.paymentStatus === 1 && remaningBalance >= 1) {
        payment = 'partial'
    } else if (rowData.paymentStatus === 2 || (rowData.paymentStatus === 1 && remaningBalance < 1)) {
        payment = 'paid'
    }

    let tax = 'notPaid'
    if (rowData.totalTaxAmountPaid > 0 && remaningBalanceWithoutTaxes >= 1) { // Partially paid
        tax = 'partial'
    } else if (rowData.totalTaxAmountPaid > 0 && remaningBalanceWithoutTaxes < 1) { // Fully paid
        tax = 'paid'
    }
    if (rowData.tcs === 0 && rowData.tds === 0) {
        tax = null
    }

    return { payment, tax }
}
